import { useState } from "react";
import { useNavigate } from "react-router-dom";

type ViewRole = "super" | "tenant" | "user";

const tenants = [
  { id: "T001", name: "朝阳燃气有限公司", city: "北京市朝阳区", users: 32456, devices: 31200, revenue: 2856320, status: "正常", plan: "企业版", expire: "2027-01-01", admin: "张总", phone: "138****0001" },
  { id: "T002", name: "海淀天然气公司", city: "北京市海淀区", users: 28123, devices: 27500, revenue: 2456210, status: "正常", plan: "专业版", expire: "2026-12-01", admin: "李总", phone: "139****0002" },
  { id: "T003", name: "西城燃气集团", city: "北京市西城区", users: 18956, devices: 18200, revenue: 1856320, status: "正常", plan: "企业版", expire: "2027-06-01", admin: "王总", phone: "137****0003" },
  { id: "T004", name: "东城燃气服务", city: "北京市东城区", users: 15234, devices: 14800, revenue: 1456210, status: "试用", plan: "基础版", expire: "2026-05-01", admin: "陈总", phone: "136****0004" },
  { id: "T005", name: "丰台燃气运营", city: "北京市丰台区", users: 22456, devices: 21900, revenue: 1956320, status: "正常", plan: "专业版", expire: "2026-09-01", admin: "刘总", phone: "135****0005" },
  { id: "T006", name: "石景山燃气", city: "北京市石景山区", users: 11231, devices: 10800, revenue: 980760, status: "欠费", plan: "基础版", expire: "2026-04-15", admin: "赵总", phone: "134****0006" },
];

const tenantUsers = [
  { id: "U001", name: "张建国", role: "管理员", dept: "系统管理", email: "zhang@chaoyang.com", status: "正常", lastLogin: "2026-04-10 09:23", permissions: ["全部"] },
  { id: "U002", name: "李秀梅", role: "运营员", dept: "营业部", email: "li@chaoyang.com", status: "正常", lastLogin: "2026-04-10 08:45", permissions: ["购气", "收费", "报表"] },
  { id: "U003", name: "王大明", role: "安检员", dept: "安检部", email: "wang@chaoyang.com", status: "正常", lastLogin: "2026-04-09 17:30", permissions: ["安检", "GIS"] },
  { id: "U004", name: "陈小红", role: "查看员", dept: "财务部", email: "chen@chaoyang.com", status: "禁用", lastLogin: "2026-04-01 10:00", permissions: ["报表"] },
  { id: "U005", name: "刘强", role: "运营员", dept: "客服部", email: "liu@chaoyang.com", status: "正常", lastLogin: "2026-04-10 09:00", permissions: ["客服", "购气"] },
];

const planFeatures = {
  "基础版": ["用户管理", "购气收费", "基础报表", "短信通知"],
  "专业版": ["基础版全部", "GIS一张图", "AI分析", "表具管理", "安检管理"],
  "企业版": ["专业版全部", "数据大屏", "AI客服", "多角色权限", "API接口", "定制开发"],
};

export default function SaasPage() {
  const navigate = useNavigate();
  const [activeRole, setActiveRole] = useState<ViewRole>("super");
  const [selectedTenant, setSelectedTenant] = useState(tenants[0]);
  const [activeTab, setActiveTab] = useState<"overview" | "tenants" | "users" | "billing" | "config">("overview");
  const [userTab, setUserTab] = useState<"list" | "roles" | "logs">("list");
  const [addUserModal, setAddUserModal] = useState(false);
  const [addTenantModal, setAddTenantModal] = useState(false);

  const totalUsers = tenants.reduce((s, t) => s + t.users, 0);
  const totalRevenue = tenants.reduce((s, t) => s + t.revenue, 0);
  const totalDevices = tenants.reduce((s, t) => s + t.devices, 0);

  const statusColor: Record<string, string> = {
    "正常": "text-green-600 bg-green-50",
    "试用": "text-amber-600 bg-amber-50",
    "欠费": "text-red-600 bg-red-50",
    "禁用": "text-gray-500 bg-gray-100",
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar */}
      <div className="bg-[#0f1729] text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#E8531A] flex items-center justify-center">
            <i className="ri-fire-line text-white text-base"></i>
          </div>
          <div>
            <div className="text-white font-bold text-sm">AI智慧燃气 · SaaS管理平台</div>
            <div className="text-white/40 text-[10px]">多租户管理控制台</div>
          </div>
        </div>

        {/* Role switcher */}
        <div className="flex gap-1 bg-white/10 rounded-xl p-1">
          {([
            { key: "super", label: "超级管理员", icon: "ri-shield-star-line" },
            { key: "tenant", label: "租户管理员", icon: "ri-building-2-line" },
            { key: "user", label: "普通用户", icon: "ri-user-3-line" },
          ] as const).map(r => (
            <button
              key={r.key}
              onClick={() => setActiveRole(r.key)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${activeRole === r.key ? "bg-[#E8531A] text-white" : "text-white/50 hover:text-white/80"}`}
            >
              <i className={r.icon}></i>
              {r.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 text-white/50 hover:text-white text-xs border border-white/20 px-3 py-1.5 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            返回系统
          </button>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-[#E8531A] flex items-center justify-center">
              <span className="text-white text-xs font-bold">超</span>
            </div>
            <span className="text-white/70 text-xs">超级管理员</span>
          </div>
        </div>
      </div>

      {/* Super Admin View */}
      {activeRole === "super" && (
        <div className="p-6">
          {/* Tabs */}
          <div className="flex gap-1 bg-white rounded-xl border border-gray-100 p-1 w-fit mb-6">
            {([
              { key: "overview", label: "平台总览", icon: "ri-dashboard-3-line" },
              { key: "tenants", label: "租户管理", icon: "ri-building-2-line" },
              { key: "billing", label: "计费管理", icon: "ri-money-cny-circle-line" },
              { key: "config", label: "平台配置", icon: "ri-settings-3-line" },
            ] as const).map(t => (
              <button
                key={t.key}
                onClick={() => setActiveTab(t.key)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${activeTab === t.key ? "bg-[#E8531A] text-white" : "text-gray-500 hover:text-gray-700"}`}
              >
                <i className={t.icon}></i>
                {t.label}
              </button>
            ))}
          </div>

          {activeTab === "overview" && (
            <>
              {/* KPI cards */}
              <div className="grid grid-cols-4 gap-4 mb-6">
                {[
                  { label: "租户总数", value: tenants.length, sub: "活跃租户", icon: "ri-building-2-line", color: "text-[#E8531A]", bg: "bg-orange-50" },
                  { label: "总用户数", value: totalUsers.toLocaleString(), sub: "全平台用户", icon: "ri-group-line", color: "text-amber-600", bg: "bg-amber-50" },
                  { label: "总设备数", value: totalDevices.toLocaleString(), sub: "在线设备", icon: "ri-cpu-line", color: "text-green-600", bg: "bg-green-50" },
                  { label: "平台总营收", value: `¥${(totalRevenue / 10000).toFixed(0)}万`, sub: "本月累计", icon: "ri-money-cny-circle-line", color: "text-cyan-600", bg: "bg-cyan-50" },
                ].map((s, i) => (
                  <div key={i} className={`${s.bg} rounded-2xl p-5`}>
                    <div className="flex items-center justify-between mb-3">
                      <div className={`w-10 h-10 rounded-xl bg-white flex items-center justify-center`}>
                        <i className={`${s.icon} ${s.color} text-lg`}></i>
                      </div>
                      <i className="ri-arrow-up-line text-green-500 text-sm"></i>
                    </div>
                    <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
                    <div className="text-xs text-gray-500 mt-1">{s.label}</div>
                    <div className="text-[10px] text-gray-400">{s.sub}</div>
                  </div>
                ))}
              </div>

              {/* Tenant list overview */}
              <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                  <h3 className="text-base font-bold text-gray-900">租户概览</h3>
                  <button
                    onClick={() => { setActiveTab("tenants"); setAddTenantModal(true); }}
                    className="flex items-center gap-1.5 bg-[#E8531A] text-white px-4 py-2 rounded-lg text-sm font-medium cursor-pointer hover:bg-[#d44a15] whitespace-nowrap"
                  >
                    <i className="ri-add-line"></i>新增租户
                  </button>
                </div>
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      {["租户名称", "城市", "用户数", "设备数", "本月营收", "套餐", "到期时间", "状态", "操作"].map(h => (
                        <th key={h} className="text-left text-xs font-medium text-gray-500 px-5 py-3">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {tenants.map(t => (
                      <tr key={t.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-5 py-3">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center">
                              <i className="ri-building-2-line text-[#E8531A] text-sm"></i>
                            </div>
                            <div>
                              <div className="text-sm font-semibold text-gray-800">{t.name}</div>
                              <div className="text-[10px] text-gray-400">{t.id}</div>
                            </div>
                          </div>
                        </td>
                        <td className="px-5 py-3 text-xs text-gray-600">{t.city}</td>
                        <td className="px-5 py-3 text-sm font-medium text-gray-800">{t.users.toLocaleString()}</td>
                        <td className="px-5 py-3 text-sm font-medium text-gray-800">{t.devices.toLocaleString()}</td>
                        <td className="px-5 py-3 text-sm font-bold text-[#E8531A]">¥{(t.revenue / 10000).toFixed(0)}万</td>
                        <td className="px-5 py-3">
                          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${t.plan === "企业版" ? "bg-[#E8531A]/10 text-[#E8531A]" : t.plan === "专业版" ? "bg-amber-50 text-amber-600" : "bg-gray-100 text-gray-500"}`}>
                            {t.plan}
                          </span>
                        </td>
                        <td className="px-5 py-3 text-xs text-gray-500">{t.expire}</td>
                        <td className="px-5 py-3">
                          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColor[t.status]}`}>{t.status}</span>
                        </td>
                        <td className="px-5 py-3">
                          <div className="flex gap-2">
                            <button
                              onClick={() => { setSelectedTenant(t); setActiveTab("tenants"); }}
                              className="text-xs text-[#E8531A] hover:underline cursor-pointer whitespace-nowrap"
                            >
                              管理
                            </button>
                            <button className="text-xs text-gray-400 hover:underline cursor-pointer whitespace-nowrap">进入</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {activeTab === "tenants" && (
            <div className="grid grid-cols-12 gap-5">
              {/* Tenant list */}
              <div className="col-span-4 space-y-3">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-bold text-gray-800">租户列表</h3>
                  <button
                    onClick={() => setAddTenantModal(true)}
                    className="flex items-center gap-1 bg-[#E8531A] text-white px-3 py-1.5 rounded-lg text-xs cursor-pointer hover:bg-[#d44a15] whitespace-nowrap"
                  >
                    <i className="ri-add-line"></i>新增
                  </button>
                </div>
                <div className="space-y-2">
                  {tenants.map(t => (
                    <div
                      key={t.id}
                      onClick={() => setSelectedTenant(t)}
                      className={`bg-white rounded-xl border p-4 cursor-pointer transition-all ${selectedTenant.id === t.id ? "border-[#E8531A]/40 bg-orange-50/30" : "border-gray-100 hover:border-gray-200"}`}
                    >
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-semibold text-gray-800">{t.name}</span>
                        <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${statusColor[t.status]}`}>{t.status}</span>
                      </div>
                      <div className="flex items-center gap-3 text-[10px] text-gray-400">
                        <span><i className="ri-group-line mr-0.5"></i>{t.users.toLocaleString()}户</span>
                        <span><i className="ri-cpu-line mr-0.5"></i>{t.devices.toLocaleString()}台</span>
                        <span className="ml-auto text-[#E8531A] font-medium">{t.plan}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tenant detail */}
              <div className="col-span-8 space-y-4">
                <div className="bg-white rounded-2xl border border-gray-100 p-6">
                  <div className="flex items-start justify-between mb-5">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900">{selectedTenant.name}</h3>
                      <p className="text-sm text-gray-400 mt-0.5">{selectedTenant.city} · {selectedTenant.id}</p>
                    </div>
                    <div className="flex gap-2">
                      <button className="flex items-center gap-1.5 border border-gray-200 text-gray-600 px-3 py-2 rounded-lg text-xs cursor-pointer hover:bg-gray-50 whitespace-nowrap">
                        <i className="ri-edit-line"></i>编辑
                      </button>
                      <button className="flex items-center gap-1.5 bg-[#E8531A] text-white px-3 py-2 rounded-lg text-xs cursor-pointer hover:bg-[#d44a15] whitespace-nowrap">
                        <i className="ri-login-box-line"></i>进入租户
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4 mb-5">
                    {[
                      { label: "用户数", value: selectedTenant.users.toLocaleString(), icon: "ri-group-line" },
                      { label: "设备数", value: selectedTenant.devices.toLocaleString(), icon: "ri-cpu-line" },
                      { label: "本月营收", value: `¥${(selectedTenant.revenue / 10000).toFixed(0)}万`, icon: "ri-money-cny-circle-line" },
                      { label: "管理员", value: selectedTenant.admin, icon: "ri-user-star-line" },
                      { label: "联系电话", value: selectedTenant.phone, icon: "ri-phone-line" },
                      { label: "到期时间", value: selectedTenant.expire, icon: "ri-calendar-line" },
                    ].map((item, i) => (
                      <div key={i} className="bg-gray-50 rounded-xl p-3">
                        <div className="flex items-center gap-1.5 mb-1">
                          <i className={`${item.icon} text-[#E8531A] text-sm`}></i>
                          <span className="text-xs text-gray-400">{item.label}</span>
                        </div>
                        <div className="text-sm font-semibold text-gray-800">{item.value}</div>
                      </div>
                    ))}
                  </div>

                  {/* Plan features */}
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-sm font-semibold text-gray-800">当前套餐：{selectedTenant.plan}</span>
                      <button className="text-xs text-[#E8531A] cursor-pointer whitespace-nowrap">升级套餐</button>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {(planFeatures[selectedTenant.plan as keyof typeof planFeatures] || []).map((f, i) => (
                        <span key={i} className="text-xs bg-orange-50 text-[#E8531A] px-2.5 py-1 rounded-full">{f}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "billing" && (
            <div className="grid grid-cols-3 gap-5">
              {[
                { plan: "基础版", price: "¥2,999/月", users: "≤5,000户", features: planFeatures["基础版"], color: "border-gray-200" },
                { plan: "专业版", price: "¥8,999/月", users: "≤30,000户", features: planFeatures["专业版"], color: "border-amber-300", popular: true },
                { plan: "企业版", price: "¥19,999/月", users: "无限制", features: planFeatures["企业版"], color: "border-[#E8531A]" },
              ].map((p, i) => (
                <div key={i} className={`bg-white rounded-2xl border-2 p-6 relative ${p.color}`}>
                  {p.popular && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-500 text-white text-xs px-3 py-1 rounded-full font-medium whitespace-nowrap">最受欢迎</div>
                  )}
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{p.plan}</h3>
                  <div className="text-2xl font-bold text-[#E8531A] mb-1">{p.price}</div>
                  <div className="text-xs text-gray-400 mb-4">用户规模：{p.users}</div>
                  <div className="space-y-2 mb-6">
                    {p.features.map((f, j) => (
                      <div key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-green-500"></i>
                        {f}
                      </div>
                    ))}
                  </div>
                  <button className={`w-full py-2.5 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap ${i === 2 ? "bg-[#E8531A] text-white" : "border border-gray-200 text-gray-700 hover:bg-gray-50"}`}>
                    {i === 2 ? "联系销售" : "选择套餐"}
                  </button>
                </div>
              ))}
            </div>
          )}

          {activeTab === "config" && (
            <div className="grid grid-cols-2 gap-5">
              {[
                { title: "AI模型配置", icon: "ri-robot-2-line", items: ["GPT-4 Turbo · 意图识别", "BERT · 情绪分析", "Whisper · 语音转文字", "RAG · 知识库检索"] },
                { title: "系统集成", icon: "ri-plug-line", items: ["短信平台 · 已连接", "邮件服务 · 已连接", "支付网关 · 已连接", "GIS地图 · 已连接"] },
                { title: "安全配置", icon: "ri-shield-check-line", items: ["数据加密 · AES-256", "传输加密 · TLS 1.3", "双因素认证 · 已启用", "操作审计 · 已启用"] },
                { title: "备份策略", icon: "ri-database-2-line", items: ["全量备份 · 每日凌晨2点", "增量备份 · 每小时", "异地容灾 · 已启用", "保留周期 · 90天"] },
              ].map((section, i) => (
                <div key={i} className="bg-white rounded-2xl border border-gray-100 p-5">
                  <div className="flex items-center gap-2 mb-4">
                    <i className={`${section.icon} text-[#E8531A] text-lg`}></i>
                    <h3 className="text-sm font-bold text-gray-800">{section.title}</h3>
                  </div>
                  <div className="space-y-2.5">
                    {section.items.map((item, j) => (
                      <div key={j} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                        <span className="text-xs text-gray-700">{item.split(" · ")[0]}</span>
                        <span className="text-xs text-green-600 font-medium">{item.split(" · ")[1]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Tenant Admin View */}
      {activeRole === "tenant" && (
        <div className="p-6">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900">朝阳燃气有限公司 · 租户管理</h2>
            <p className="text-sm text-gray-400 mt-0.5">企业版 · 到期时间：2027-01-01</p>
          </div>

          <div className="flex gap-1 bg-white rounded-xl border border-gray-100 p-1 w-fit mb-6">
            {([
              { key: "list", label: "用户列表", icon: "ri-group-line" },
              { key: "roles", label: "角色权限", icon: "ri-shield-user-line" },
              { key: "logs", label: "操作日志", icon: "ri-history-line" },
            ] as const).map(t => (
              <button
                key={t.key}
                onClick={() => setUserTab(t.key)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${userTab === t.key ? "bg-[#E8531A] text-white" : "text-gray-500 hover:text-gray-700"}`}
              >
                <i className={t.icon}></i>
                {t.label}
              </button>
            ))}
          </div>

          {userTab === "list" && (
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                <h3 className="text-sm font-bold text-gray-800">系统用户管理</h3>
                <button
                  onClick={() => setAddUserModal(true)}
                  className="flex items-center gap-1.5 bg-[#E8531A] text-white px-4 py-2 rounded-lg text-sm font-medium cursor-pointer hover:bg-[#d44a15] whitespace-nowrap"
                >
                  <i className="ri-user-add-line"></i>新增用户
                </button>
              </div>
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    {["用户", "角色", "部门", "邮箱", "状态", "最后登录", "操作"].map(h => (
                      <th key={h} className="text-left text-xs font-medium text-gray-500 px-5 py-3">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {tenantUsers.map(u => (
                    <tr key={u.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-5 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 rounded-full bg-[#E8531A] flex items-center justify-center">
                            <span className="text-white text-xs font-bold">{u.name[0]}</span>
                          </div>
                          <span className="text-sm font-medium text-gray-800">{u.name}</span>
                        </div>
                      </td>
                      <td className="px-5 py-3">
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${u.role === "管理员" ? "bg-[#E8531A]/10 text-[#E8531A]" : u.role === "运营员" ? "bg-amber-50 text-amber-600" : u.role === "安检员" ? "bg-green-50 text-green-600" : "bg-gray-100 text-gray-500"}`}>
                          {u.role}
                        </span>
                      </td>
                      <td className="px-5 py-3 text-xs text-gray-600">{u.dept}</td>
                      <td className="px-5 py-3 text-xs text-gray-500">{u.email}</td>
                      <td className="px-5 py-3">
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColor[u.status]}`}>{u.status}</span>
                      </td>
                      <td className="px-5 py-3 text-xs text-gray-400">{u.lastLogin}</td>
                      <td className="px-5 py-3">
                        <div className="flex gap-2">
                          <button className="text-xs text-[#E8531A] hover:underline cursor-pointer whitespace-nowrap">编辑</button>
                          <button className="text-xs text-gray-400 hover:underline cursor-pointer whitespace-nowrap">{u.status === "正常" ? "禁用" : "启用"}</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {userTab === "roles" && (
            <div className="grid grid-cols-3 gap-4">
              {[
                { role: "管理员", icon: "ri-shield-star-line", color: "text-[#E8531A]", bg: "bg-orange-50", perms: ["用户管理", "系统配置", "数据导出", "全部业务模块", "AI分析", "报表管理"] },
                { role: "运营员", icon: "ri-user-settings-line", color: "text-amber-600", bg: "bg-amber-50", perms: ["购气操作", "收费管理", "客户档案", "安检管理", "报装业务", "短信催缴"] },
                { role: "查看员", icon: "ri-eye-line", color: "text-green-600", bg: "bg-green-50", perms: ["数据查看", "报表查看", "GIS查看", "告警查看"] },
              ].map((r, i) => (
                <div key={i} className="bg-white rounded-2xl border border-gray-100 p-5">
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 rounded-xl ${r.bg} flex items-center justify-center`}>
                      <i className={`${r.icon} ${r.color} text-lg`}></i>
                    </div>
                    <div>
                      <div className="text-sm font-bold text-gray-900">{r.role}</div>
                      <div className="text-xs text-gray-400">{r.perms.length}项权限</div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    {r.perms.map((p, j) => (
                      <div key={j} className="flex items-center gap-2 text-xs text-gray-600">
                        <i className="ri-check-line text-green-500"></i>
                        {p}
                      </div>
                    ))}
                  </div>
                  <button className="w-full mt-4 border border-gray-200 text-gray-600 py-2 rounded-xl text-xs cursor-pointer hover:bg-gray-50 whitespace-nowrap">
                    编辑权限
                  </button>
                </div>
              ))}
            </div>
          )}

          {userTab === "logs" && (
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100">
                <h3 className="text-sm font-bold text-gray-800">操作审计日志</h3>
              </div>
              <div className="divide-y divide-gray-50">
                {[
                  { user: "张建国", action: "登录系统", module: "认证", time: "2026-04-10 09:23:15", ip: "192.168.1.101", result: "成功" },
                  { user: "李秀梅", action: "购气操作", module: "营业收费", time: "2026-04-10 09:15:32", ip: "192.168.1.102", result: "成功" },
                  { user: "王大明", action: "安检记录提交", module: "安检管理", time: "2026-04-10 08:45:10", ip: "192.168.1.103", result: "成功" },
                  { user: "陈小红", action: "导出报表", module: "报表管理", time: "2026-04-10 08:30:05", ip: "192.168.1.104", result: "成功" },
                  { user: "刘强", action: "修改用户信息", module: "客户管理", time: "2026-04-10 08:15:22", ip: "192.168.1.105", result: "成功" },
                  { user: "未知", action: "登录失败", module: "认证", time: "2026-04-10 07:55:18", ip: "10.0.0.55", result: "失败" },
                ].map((log, i) => (
                  <div key={i} className="px-6 py-3 flex items-center gap-4 hover:bg-gray-50">
                    <div className="w-7 h-7 rounded-full bg-[#E8531A] flex items-center justify-center flex-shrink-0">
                      <span className="text-white text-xs font-bold">{log.user[0]}</span>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-800">{log.user}</span>
                        <span className="text-xs text-gray-400">{log.action}</span>
                        <span className="text-xs bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded">{log.module}</span>
                      </div>
                      <div className="text-xs text-gray-400 mt-0.5">{log.time} · {log.ip}</div>
                    </div>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${log.result === "成功" ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600"}`}>
                      {log.result}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* User View */}
      {activeRole === "user" && (
        <div className="p-6">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900">个人工作台</h2>
            <p className="text-sm text-gray-400 mt-0.5">李秀梅 · 运营员 · 朝阳燃气有限公司</p>
          </div>

          <div className="grid grid-cols-3 gap-5">
            {/* Quick access */}
            <div className="col-span-2 bg-white rounded-2xl border border-gray-100 p-5">
              <h3 className="text-sm font-bold text-gray-800 mb-4">快捷入口</h3>
              <div className="grid grid-cols-4 gap-3">
                {[
                  { label: "购气操作", icon: "ri-shopping-cart-2-line", path: "/sales/purchase", color: "bg-orange-50 text-[#E8531A]" },
                  { label: "收费窗口", icon: "ri-bank-card-line", path: "/payment", color: "bg-amber-50 text-amber-600" },
                  { label: "客户档案", icon: "ri-user-3-line", path: "/profile/resident", color: "bg-green-50 text-green-600" },
                  { label: "安检管理", icon: "ri-shield-check-line", path: "/safety", color: "bg-cyan-50 text-cyan-600" },
                  { label: "报表查看", icon: "ri-bar-chart-box-line", path: "/report", color: "bg-purple-50 text-purple-600" },
                  { label: "短信催缴", icon: "ri-message-2-line", path: "/sms", color: "bg-pink-50 text-pink-600" },
                  { label: "GIS地图", icon: "ri-map-2-line", path: "/gis", color: "bg-teal-50 text-teal-600" },
                  { label: "告警中心", icon: "ri-alarm-warning-line", path: "/alarm", color: "bg-red-50 text-red-600" },
                ].map((item, i) => (
                  <button
                    key={i}
                    onClick={() => navigate(item.path)}
                    className={`flex flex-col items-center gap-2 p-4 rounded-xl cursor-pointer hover:opacity-80 transition-opacity ${item.color}`}
                  >
                    <i className={`${item.icon} text-2xl`}></i>
                    <span className="text-xs font-medium">{item.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Personal info */}
            <div className="space-y-4">
              <div className="bg-white rounded-2xl border border-gray-100 p-5">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-full bg-[#E8531A] flex items-center justify-center">
                    <span className="text-white text-lg font-bold">李</span>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">李秀梅</div>
                    <div className="text-xs text-gray-400">运营员 · 营业部</div>
                  </div>
                </div>
                <div className="space-y-2">
                  {[
                    { label: "所属租户", value: "朝阳燃气有限公司" },
                    { label: "角色权限", value: "运营员" },
                    { label: "最后登录", value: "2026-04-10 08:45" },
                  ].map((item, i) => (
                    <div key={i} className="flex justify-between text-xs">
                      <span className="text-gray-400">{item.label}</span>
                      <span className="text-gray-700 font-medium">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-2xl border border-gray-100 p-5">
                <h4 className="text-sm font-bold text-gray-800 mb-3">今日工作统计</h4>
                <div className="space-y-2">
                  {[
                    { label: "处理购气", value: "12笔", color: "text-[#E8531A]" },
                    { label: "收费金额", value: "¥8,560", color: "text-amber-600" },
                    { label: "客服接待", value: "8人次", color: "text-green-600" },
                  ].map((item, i) => (
                    <div key={i} className="flex justify-between text-xs">
                      <span className="text-gray-400">{item.label}</span>
                      <span className={`font-bold ${item.color}`}>{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Tenant Modal */}
      {addTenantModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setAddTenantModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[480px]" onClick={e => e.stopPropagation()}>
            <h3 className="text-base font-bold text-gray-900 mb-4">新增租户</h3>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-gray-500 mb-1 block">公司名称 *</label>
                <input type="text" placeholder="请输入公司全称" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500 mb-1 block">管理员姓名</label>
                  <input type="text" placeholder="管理员姓名" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
                </div>
                <div>
                  <label className="text-xs text-gray-500 mb-1 block">联系电话</label>
                  <input type="tel" placeholder="手机号" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">套餐选择</label>
                <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                  <option>基础版</option>
                  <option>专业版</option>
                  <option>企业版</option>
                </select>
              </div>
              <div className="flex gap-2 pt-1">
                <button onClick={() => setAddTenantModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2 rounded-lg text-sm cursor-pointer hover:bg-gray-50 whitespace-nowrap">取消</button>
                <button onClick={() => setAddTenantModal(false)} className="flex-1 bg-[#E8531A] text-white py-2 rounded-lg text-sm cursor-pointer hover:bg-[#d44a15] whitespace-nowrap">创建租户</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add User Modal */}
      {addUserModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setAddUserModal(false)}>
          <div className="bg-white rounded-2xl p-6 w-[440px]" onClick={e => e.stopPropagation()}>
            <h3 className="text-base font-bold text-gray-900 mb-4">新增用户</h3>
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500 mb-1 block">姓名 *</label>
                  <input type="text" placeholder="真实姓名" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
                </div>
                <div>
                  <label className="text-xs text-gray-500 mb-1 block">用户名 *</label>
                  <input type="text" placeholder="登录用户名" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">角色 *</label>
                <select className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]">
                  <option>管理员</option>
                  <option>运营员</option>
                  <option>安检员</option>
                  <option>查看员</option>
                </select>
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">初始密码</label>
                <input type="password" placeholder="设置初始密码" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#E8531A]" />
              </div>
              <div className="flex gap-2 pt-1">
                <button onClick={() => setAddUserModal(false)} className="flex-1 border border-gray-200 text-gray-600 py-2 rounded-lg text-sm cursor-pointer hover:bg-gray-50 whitespace-nowrap">取消</button>
                <button onClick={() => setAddUserModal(false)} className="flex-1 bg-[#E8531A] text-white py-2 rounded-lg text-sm cursor-pointer hover:bg-[#d44a15] whitespace-nowrap">创建用户</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
